module.exports = __webpack_public_path__ + "static/media/big_loc.6482dadb.svg";